const Subscriptions = () => import("Modules/subscriptions/views/Subscriptions");
const SubscriptionsForm = () => import("Modules/subscriptions/views/SubscriptionsForm");

export default {
    children: [
        {
            path: "subscriptions",
            name: "subscriptions",
            component: Subscriptions,
            meta: {
                requiresAuth: true,
                title: "lang.subscriptions",
                restrict_by_login_type: [
                    "customer_support",
                    "administrator",
                    "employee",
                    "developer",
                    "csr",
                    "customer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "employee",
                    "customer",
                ],
                restrict_by_permission: ["subscriptions.read"],
                tabTitle: "Subscriptions",
            },
        },
        {
            path: "subscription/:id?",
            name: "subscription",
            component: SubscriptionsForm,
            meta: {
                requiresAuth: true,
                title: "lang.subscriptions",
                restrict_by_login_type: [
                    "customer_support",
                    "administrator",
                    "employee",
                    "developer",
                    "csr",
                    "customer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "employee",
                    "customer",
                ],
                restrict_by_permission: ["subscriptions.read"],
                tabTitle: "Subscriptions",
            },
        },
    ],
};
